export const PageHeadings = {
  BLS_FEEDBACK: "BLS Feedback",
  CUSTOMER_MANAGAMENT: "Customer Management",
  NOTIFICATION_MANAGEMENT: "Notification Management",
  CLICK_ANALYTICS: "Click Analytics",
};
